import { useState } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/base/Seo";
import { faqs } from "@/mocks/faq";

function Item({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="overflow-hidden rounded-xl border border-background-800 bg-background-900">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex w-full cursor-pointer items-center justify-between gap-3 px-4 py-4 text-left md:px-6"
        aria-expanded={open}
      >
        <span className="text-sm font-medium text-foreground-950 md:text-base">{q}</span>
        <i className={`shrink-0 text-lg text-primary-400 transition-transform ${open ? "rotate-45" : ""} ri-add-line`} />
      </button>
      {open && <p className="border-t border-background-800 px-4 py-4 text-sm leading-7 text-foreground-500 md:px-6">{a}</p>}
    </div>
  );
}

export default function Faq() {
  return (
    <div className="pt-16 md:pt-[72px]">
      <Seo
        title="常见问题 | 虚空漫画网"
        description="关于虚空漫画网收录范围、热门榜单更新频率、免费阅读、评分机制与追更收藏的常见问题解答。"
        path="/faq"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: "https://talespots.github.io" },
              { "@type": "ListItem", position: 2, name: "常见问题", item: "https://talespots.github.io/faq" },
            ],
          },
        ]}
      />

      <section className="mx-auto max-w-3xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-background-900/50 px-4 py-1.5 text-xs font-medium text-primary-300">
            <i className="ri-question-line text-sm" />
            常见问题
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black text-foreground-950 md:text-5xl">你可能想知道的</h1>
          <p className="mx-auto mt-4 max-w-xl text-sm text-foreground-500 md:text-base">
            关于收录、榜单、评分与追更的常见疑问，这里都给你说明白。没找到答案？欢迎联系我们。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f) => (
            <Item key={f.q} q={f.q} a={f.a} />
          ))}
        </div>

        <div className="mt-10 rounded-2xl border border-primary-500/30 bg-gradient-to-br from-background-900 to-primary-500/10 p-6 text-center md:p-8">
          <h2 className="font-heading text-lg font-black text-foreground-950">还有疑问？</h2>
          <p className="mt-2 text-sm text-foreground-500">想咨询、反馈或推荐新作，随时联系我们。</p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link to="/contact" className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-600">
              联系客服
            </Link>
            <Link to="/" className="cursor-pointer whitespace-nowrap rounded-full border border-background-700 px-6 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-500/50 hover:text-primary-300">
              返回首页
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}